"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Item.scss");
var Item = function Item() {
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "cds-CartItem cds-Listing-Item"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CartItem-Image cds-Skeleton--Thumb"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CartItem-Title cds-Skeleton--TextFull"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CartItem-StockCount cds-StockCount cds-Skeleton--TextShort"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CartItem-Price cds-Skeleton--TextShort"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CartItem-Quantity cds-Skeleton--TextShort"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CartItem-PriceTotal cds-Skeleton--TextShort"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CartItem-Details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CartItem-StockCountMobiles cds-Skeleton--TextMedium"
  })));
};
exports.Item = Item;